import getBillingAccountQuery from '~/javascripts/billing_account/graphql/queries/get_billing_account.query.graphql';
import { COUNTRIES_TO_HIDE_TAX_ID } from '~/javascripts/constants';

export function getCompanyDetails(companyDetails, country) {
  if (COUNTRIES_TO_HIDE_TAX_ID.includes(country)) {
    return { ...companyDetails, taxId: undefined };
  }

  return companyDetails;
}

export function updateBillingAccountCache(cache, zuoraAccountNumber, updateData = {}) {
  const data = cache.readQuery({
    query: getBillingAccountQuery,
    variables: { zuoraAccountNumber },
  });

  if (data?.billingAccount) {
    cache.writeQuery({
      query: getBillingAccountQuery,
      variables: { zuoraAccountNumber },
      data: {
        billingAccount: {
          ...data.billingAccount,
          ...updateData,
        },
      },
    });
  }
}
